import { render } from "./compra-editar.vue?vue&type=template&id=6690d0df"
import script from "./compra-editar.vue?vue&type=script&lang=js"
export * from "./compra-editar.vue?vue&type=script&lang=js"

import "./compra-editar.vue?vue&type=style&index=0&id=6690d0df&lang=css"

import exportComponent from "C:\\Users\\iuril\\Documents\\econopro\\mainapp\\mtex_mobagile_m3_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__